import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import { useNavigate } from "react-router-dom";
import { SITE_URL } from "../../services/Const";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";

const SalesProductCount = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        getData();

    }, []);

    const getData = () => {
        setLoading(true);
        setData([]); // Reset data before fetching new data

        axiosConfig.get(`product-wise-sale-count`, setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setLoading(false); // ✅ This will run after the promise resolves/rejects
            });
    };

    

    // Show loading state first
    if (loading) {
        return (
            <LoadingComponent breadCrubTitle='Order Details' breadCrubParent='Sales Report' />
        );
    }

    // Show no data only after loading is complete and data is empty
    if (!loading && data.length === 0) {
        return (
            <Fragment>
                <Breadcrumb title="Order Details" parent="Sales Report" />
                <NoDataHandler title='Order Details Not Found' />
            </Fragment>
        );
    }
    return (
        <Fragment>
            <Breadcrumb title="Order Details" parent="Sales Report" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Product Code</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Product Name</th>
                                        <th scope="col">Totel Sale Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <th scope="row">{item.productCode}</th>
                                                <td>
                                                    <img
                                                        width="100"
                                                        height="50"
                                                        src={`${SITE_URL}/images/product/${JSON.parse(item.images || "[]")[0]}`} alt="" />
                                                </td>
                                                <td>{item.productName}</td>
                                                <td>{item.total_sales_count}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <button className="btn btn-primary" style={{ marginTop: '1rem' }} onClick={() => navigate(-1)}>Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default SalesProductCount;